export default __webpack_public_path__ + "static/media/magento-logo.cbeef404.png";